import { useAppForm } from "@/components/ui/forms/hooks/useFormHook"
import { errorToastClassName } from "@/components/ui/baseUi/sonner"
import { sendCodeFieldsSchema, type SendCodeFields } from "@/modules/auth/authTypes"
import { useLanguage } from "@/modules/language/hooks/useLanguage"
import { getAuthError } from "@modules/auth/authError"
import { AuthContent, AuthForm, AuthHeader, AuthPage, AuthSubmitButton } from "@modules/auth/components/authComponents"
import { LoginBack } from "@modules/auth/components/loginBack"
import { word } from "@modules/core/utils/i18n"
import { Path } from "@modules/navigation/routes"
import { LoggerType } from "@modules/utils/loggerUtils"
import { AuthError as AmplifyAuthError, resetPassword } from "aws-amplify/auth"
import { useLocation, useNavigate } from "react-router"
import { toast } from "sonner"

const defaultValues: SendCodeFields = {
  email: "",
}

export function SendCodePage() {
  const navigate = useNavigate()
  const location = useLocation() as { state?: { email?: string } }
  const language = useLanguage()
  const sendForgotPasswordConfirmationCode = async () => {
    try {
      await resetPassword({ username: form.state.values.email })
      void navigate(
        { pathname: Path.ResetPassword },
        { state: { email: form.state.values.email, isRequiredPassword: false } },
      )
    } catch (e) {
      console.error(LoggerType.Login + "send confimation code password", e)
      if (e instanceof AmplifyAuthError) {
        toast.error(getAuthError(e, { onlyEmail: true }), { classNames: errorToastClassName() })
      } else {
        toast.error(word("global.error.default"), { classNames: errorToastClassName() })
      }
    }
  }

  const form = useAppForm({
    defaultValues: {
      ...defaultValues,
      email: location.state?.email ?? "",
    },
    validators: {
      onSubmit: sendCodeFieldsSchema(language),
      onBlur: sendCodeFieldsSchema(language),
    },
    onSubmit: sendForgotPasswordConfirmationCode,
  })

  return (
    <AuthPage>
      <AuthForm
        onSubmit={(e) => {
          e.preventDefault()
          void form.handleSubmit()
        }}
      >
        <AuthHeader title={word("auth.signup.form.reset_password")} subtitle={word("auth.send_code.form.subtitle")} />

        <AuthContent>
          <form.AppField name="email">
            {(field) => (
              <field.Field>
                <field.Content>
                  <field.Input name="email" placeholder={word("auth.form.placeholder.email")} />
                  <field.Message />
                </field.Content>
              </field.Field>
            )}
          </form.AppField>

          <form.Subscribe selector={(state) => [state.canSubmit, state.isSubmitting]}>
            {([canSubmit, isSubmitting]) => (
              <AuthSubmitButton loading={isSubmitting} disabled={!canSubmit} buttonLabel={word("global.check")} />
            )}
          </form.Subscribe>

          <LoginBack emailState={form.state.values.email} />
        </AuthContent>
      </AuthForm>
    </AuthPage>
  )
}
